import React from 'react';
import classnames from 'classnames';
import styles from './AZ.module.scss';

interface AZListItemProps {
    label: string;
    activeLetter: string;
    handleClick: (letter: string) => void;
}

const AZListItem: React.FC<AZListItemProps> = props => {
    const isActive = props.label === props.activeLetter;

    return (
        <button
            id={classnames(
                { 'az-az-list-item': !isActive },
                { 'az-az-list-item-active': isActive },
            )}
            className={classnames(styles.azListItem, {
                [styles.azListItemActive]: isActive,
            })}
            onClick={() => props.handleClick(props.label)}
        >
            {props.label}
        </button>
    );
};

export default AZListItem;
